import { render, staticRenderFns } from "./ComboStatus.vue?vue&type=template&id=ec629a7e"
import script from "./ComboStatus.vue?vue&type=script&lang=ts"
export * from "./ComboStatus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports